// Importing translations for each language
import * as german from './de'
import * as english from './en'
import * as spanish from './es'
import * as french from './fr'

interface TranslationFile {
  [key: string]: string
}

// Define the type for the language module.
//
// A `type`, not an `interface`, and the difference is load-bearing: i18next's
// `ResourceLanguage` is indexed by namespace, and TypeScript gives an object
// type alias an implicit index signature while an interface gets none. As an
// interface this was not assignable to `ResourceLanguage`, so every
// `i18n.init(config)` call in the app failed to type-check.
//
// Writing the index signature by hand would also work and would be worse: it
// makes `keyof LanguageModule` collapse to `string`, and the `translations`
// list below relies on that key union to stay exhaustive.
type LanguageModule = {
  common: TranslationFile
  lines_overview: TranslationFile
  line_signals: TranslationFile
  batch_traceability: TranslationFile
  login: TranslationFile
  errors: TranslationFile
  tutorial: TranslationFile
  settings: TranslationFile
  line_management: TranslationFile
  dashboards: TranslationFile
  compare_pdfs: TranslationFile
  start_up_kit_onboarding: TranslationFile
  edge_api: TranslationFile
  home: TranslationFile
  cockpit: TranslationFile
  anomalies: TranslationFile
  logbook: TranslationFile
  incidents: TranslationFile
  timerange: TranslationFile
  program_signal_threshold: TranslationFile
  alpinist: TranslationFile
  digital_twin: TranslationFile
  tasks: TranslationFile
}

const translations: (keyof LanguageModule)[] = [
  'alpinist',
  'anomalies',
  'batch_traceability',
  'cockpit',
  'logbook',
  'common',
  'compare_pdfs',
  'dashboards',
  'digital_twin',
  'edge_api',
  'errors',
  'home',
  'incidents',
  'line_management',
  'line_signals',
  'lines_overview',
  'login',
  'program_signal_threshold',
  'settings',
  'start_up_kit_onboarding',
  'tasks',
  'timerange',
  'tutorial',
]

const getTranslationObject = (language: unknown): LanguageModule =>
  translations.reduce<LanguageModule>((acc, key) => {
    acc[key] = (language as LanguageModule)[key]
    return acc
  }, {} as LanguageModule)

export default {
  en: getTranslationObject(english),
  de: getTranslationObject(german),
  fr: getTranslationObject(french),
  es: getTranslationObject(spanish),
}
